import React, { useEffect, useState } from "react";
import { useQuery } from "@apollo/react-hooks";
import { Loading } from "components/common";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { ENROLLMENT_STATUS } from "utils/constants";
import BoostEnrolled from "./BoostEnrolled";
import BoostLanding from "./BoostLanding";
import BoostWaiting from "./BoostWaiting";
import BoostTerminated from "./BoostTerminated";
import BoostOnboarding from "./BoostOnboarding";
import { GET_PRODUCT_STATUS, GET_BOOST_BASIC_INFO } from "./mutations";
import BoostLandingCreditCardUser from "./BoostLandingCreditCardUser";

const Boost = ({ roles, ...props }) => {
  const searchParams = new URLSearchParams(props.location.search);
  const urlStatus = searchParams.get("status");
  const sessionId = searchParams.get("session_id");
  const clientSecret = searchParams.get("payment_intent_client_secret");

  const [completedOnboarding, setCompletedOnboarding] = useState(false);

  useEffect(() => {
    // fixes scroll behavior on some iOS browsers
    window?.scrollTo(0,0);
  }, []);

  const { data, loading } = useQuery(GET_PRODUCT_STATUS, {
    fetchPolicy: "network-only",
  });

  const { data: BasicUserInfo, loading: BasicUserLoading } = useQuery(GET_BOOST_BASIC_INFO, {
    variables: {
      sessionId,
      clientSecret,
    },
    fetchPolicy: "network-only",
  });

  if (loading || BasicUserLoading) {
    return <Loading boost />;
  }

  const productStatus = data?.getUserProductStatus?.status;
  const currentProductTier = data?.getUserProductStatus?.productTier;
  const currentProductTerm = data?.getUserProductStatus?.productTerm;
  const isFreeTrial = data?.getUserProductStatus?.productFreeTrial;

  const renderSwitch = () => {
    if (urlStatus === ENROLLMENT_STATUS.WAITING && productStatus !== ENROLLMENT_STATUS.ENROLLED) {
      return <BoostWaiting history={props.history} />;
    }
    if (urlStatus === ENROLLMENT_STATUS.WAITING) {
      searchParams.delete("status");
      props.history.replace({
        search: searchParams.toString(),
      });
    }

    const { getUserBasicInfo } = BasicUserInfo;
    const { stripeUser = {}, user = {} } = getUserBasicInfo || {};
    let requiresOnboarding = false;
    Object.keys(user).forEach((key) => {
      if (key === 'applicationStatus') { return; }
      if (!user[key] || (Array.isArray(user[key]) && user[key].length === 0)) {
        requiresOnboarding = true;
      }
    });

    const isCreditCardUser = !!roles?.credit_card;

    switch (productStatus) {
      case ENROLLMENT_STATUS.ENROLLED:
        if (
          requiresOnboarding
          && !completedOnboarding
        ) {
          return <BoostOnboarding
            stripeUser={stripeUser}
            user={user}
            currentProductTier={currentProductTier}
            currentProductTerm={currentProductTerm}
            setCompletedOnboarding={setCompletedOnboarding}
          />;
        }
        return <BoostEnrolled
          currentProductTier={currentProductTier}
          currentProductTerm={currentProductTerm}
          isFreeTrial={isFreeTrial}
          user={user}
        />;
      case ENROLLMENT_STATUS.TERMINATED:
        return <BoostTerminated
          currentProductTier={currentProductTier}
          currentProductTerm={currentProductTerm}
          user={user}
        />;
      default:
        return isCreditCardUser ? <BoostLandingCreditCardUser user={user} /> : <BoostLanding user={user} />;
    }
  };

  return (
    <div
      className="h-full"
    >
      {renderSwitch()}
    </div>
  );
};

const mapStateToProps = (state) => ({
  roles: state.user.roles,
});

export default withRouter(connect(mapStateToProps)(Boost));
